import React, { memo, lazy } from 'react';
import './index.css';

const HeaderCallSection = lazy(() => import('./HeaderCallSection'));
const MobileMenuLinks = lazy(() => import('./MenuLinks/MobileMenuLinks'));
const DesktopMenuLinks = lazy(() => import('./MenuLinks/DesktopMenuLinks'));

const Header = memo(() => {
  const marketingBaseUrl = process.env.REACT_APP_MARKETING_BASE_URL || '#';

  return (
    <div className="header-wrapper">
      <div className="header-content">
        {/* LEFT SECTION - Logo */}
        <a href={`${marketingBaseUrl}/`} className="header-logo">
          <img src="/newIcons/Header/travelopod-logo.webp" alt="Travelopod Logo" width={150} height={30} />
          <p className="header-slogan">Flights Lower Than Online</p>
        </a>

        {/* DESKTOP -> NAVIGATION LINKS */}
        <div className="desktop-navigation">
          <DesktopMenuLinks />
        </div>

        {/* CALL TO ACTION BUTTONS */}
        <div className="cta-buttons">
          {/* EMAIL ICON -> ONLY ON MOBILE VIEW */}
          <a className="email-icon" href="mailto:contact@travelopod.com" aria-label="Email us">
            <img src="/newIcons/Header/mail.svg" alt="Email us at contact@travelopod.com" width={24} height={24} />
          </a>

          {/* CALL ICON */}
          <HeaderCallSection />

          {/* MOBILE - Navigation Links */}
          <div className="mobile-navigation">
            <MobileMenuLinks />
          </div>
        </div>
      </div>
    </div>
  );
});

export default Header;
